const getMimeType = (sig: string) => {
  switch (sig) {
    case '89504E47': return 'image/png'
    case '47494638': return 'image/gif'
    case '49492A00':
    case '4D4D002A':
    case '4D4D002B': return 'image/tiff'
    case 'FFD8FFE0':
    case 'FFD8FFE1':
    case 'FFD8FFE2':
    case 'FFD8FFE3':
    case 'FFD8FFE8':
    case 'FFD8FFDB': return 'image/jpg'
    case '424D5614': return 'image/bpm'
    case '3C3F786D': return 'image/svg'
    default: return 'application/octet-stream' // change to unsupported after
  }
}

export { getMimeType }
